import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  height: ${props => props.$heights[0]}px;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: 769px) and (max-width: 1024px) {
    height: ${props => props.$heights[1]}px;
  }

  @media (max-width: 768px) {
    height: ${props => props.$heights[2]}px;
  }
`;

const TopDummy = ({ heights }) => {
  return (
    <div className="TopDummy">
      <StyledDiv $heights={heights} />
    </div>
  );
};

export default TopDummy;